// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Check as RawCheck } from "lucide-react";
export const Check = /* @__PURE__ */ createIcon(RawCheck, "Check", 2);
